/**
 * Test IDs for QA automation.
 */
export const testIds = {
  receiverForecastsListNewModel: "receiver-forecasts-list-new-model",
} as const;
